<template>
  <img
    v-if="isBasic"
    v-bind="$attrs"
    src="@/assets/img/star-essential.svg"
    alt="Étoile argentée"
  />
  <img
    v-if="isSocietal"
    v-bind="$attrs"
    src="@/assets/img/star-societal.svg"
    alt="Étoile dorée"
  />
</template>

<script setup>
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";
import { computed } from "vue";
const props = defineProps({
  permissionLevel: { type: String, required: true },
});

const isBasic = computed(
  () =>
    props.permissionLevel === PermissionLevel.BASIC ||
    props.permissionLevel === PermissionLevel.TEAMS_BASIC
);

const isSocietal = computed(
  () =>
    props.permissionLevel === PermissionLevel.SOCIETAL ||
    props.permissionLevel === PermissionLevel.TEAMS_SOCIETAL
);
</script>
